import { render, staticRenderFns } from "./SpaceSelector.vue?vue&type=template&id=edc1e0d8&scoped=true"
import script from "./SpaceSelector.vue?vue&type=script&lang=ts"
export * from "./SpaceSelector.vue?vue&type=script&lang=ts"
import style0 from "./SpaceSelector.vue?vue&type=style&index=0&id=edc1e0d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edc1e0d8",
  null
  
)

export default component.exports